export default "__VITE_ASSET__19e0a75a__"